import React, {useEffect, useRef, useState} from "react";
import { Editor } from "react-draft-wysiwyg";
import {EditorState, convertToRaw, ContentState} from "draft-js";
import { Grid } from "@mui/material";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import '../../css/TextEditorRebrand.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { decode } from "html-entities";


export default function TextEditorRebranded(props) {
   const editorRef = useRef();
   const [hasBeenFocused, setHasBeenFocused] = useState(false);
   const [isSetInitialText, setIsSetInitialText] = useState(false);

   let textEditorTextLength = props.textEditorTextLength;
   
   const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

   const currentContent = editorState.getCurrentContent();
   const currentContentLength = currentContent.getPlainText('').length

   useEffect(() => {
      const trimmed = typeof props.currentText === 'string' ? props.currentText.trim() : props.currentText;
      if (!trimmed) {
        setEditorState(EditorState.createEmpty());
        setIsSetInitialText(false);
        return;
      }
      const isEditorEmpty = !editorState.getCurrentContent().hasText();
      if (props.currentText && isEditorEmpty && !isSetInitialText) {
        const blocksFromHtml = htmlToDraft(props.currentText);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(EditorState.moveFocusToEnd(newEditorState));
        setIsSetInitialText(true);         
       } 
       // reseting editor state when user discard bio changes
       else if ((props.currentText === decode(props?.influencer_info?.["description"] || "")) && props?.influencerDescriptionUpdated === null && props?.influencer_info?.description) {
         const currentEditorHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
         const originalDescription = decode(props?.influencer_info?.["description"] || "");
         
         // Compare the current editor content with the original description
         const currentEditorStr = String(currentEditorHtml).trim();
         const originalDescStr = String(originalDescription).trim();
         
         // If they don't match, reset the editor to show the original description
         if (currentEditorStr !== originalDescStr) {
             const blocksFromHtml = htmlToDraft(originalDescription);
             const { contentBlocks, entityMap } = blocksFromHtml;
             const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
             const newEditorState = EditorState.createWithContent(contentState);
             setEditorState(EditorState.moveFocusToEnd(newEditorState));
             setIsSetInitialText(true);
         }
       }  

   }, [props.currentText]);

   useEffect(() => {
      // Focus the editor when the component mounts
      if (props.modalPopupEditor === true) {
      editorRef.current.focusEditor();

      // Move the cursor to the end of the content
      const updatedEditorState = EditorState.moveFocusToEnd(editorState);
      setEditorState(updatedEditorState);
      }
   }, []);

   useEffect(() => {
      if (!props.editedBio) {
         setHasBeenFocused(false);
      }
   }, [props.editedBio]);

   useEffect( () => {
    props.parentCallback(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    props.lengthCallback(currentContentLength);

       if (currentContentLength <= textEditorTextLength) {
          props.parentCallback(draftToHtml(convertToRaw(editorState.getCurrentContent())));
          props.lengthCallback(currentContentLength);
       } else {
          props.lengthCallback(currentContentLength);
        //   props.snackbarCallback()
       }

 }, [editorState]);

    let wrapper_class_name = ""
    let editor_class_name = ""
    let toolbar_class_name = ""
    let bio_error_div = ''
    if (props.page === 'bio'){
        editor_class_name = "editorClassNameShort"
        if ((currentContentLength === 0) & (props.editedBio === false)){
            wrapper_class_name = "wrapperClassName"
            toolbar_class_name = "toolbarClassName"
            bio_error_div = ''
        }
        else if ((currentContentLength <= textEditorTextLength) & (currentContentLength >= 4)){
            wrapper_class_name = "wrapperClassNameGreen"
            toolbar_class_name = "toolbarClassNameGreen"
            bio_error_div = ''
        } else {
            wrapper_class_name = "wrapperClassNameError"
            toolbar_class_name = "toolbarClassNameError"
            bio_error_div = (
                // <span className={'alignleft'} style={{marginTop: '0px', textAlign:'left',color:'#FD2B2B',fontSize:'11px'}}>Bio must be between 4 and 200 characters</span>
                ''
            )
        }
    } else {
        wrapper_class_name = "wrapperClassName"
        toolbar_class_name = "toolbarClassName"
        if (props.editorClassName === undefined){
            editor_class_name = "editorClassName"
        } else {
            editor_class_name = props.editorClassName
        }
    }

    const handleFocus = () => {
      if (props.page === "bio" && props.onFocus && !hasBeenFocused) {
         setHasBeenFocused(true);
         props.onFocus();
      }
   };

    // Ensure inline formatting tools (bold, italic, underline), list (bullet points), and textAlign are included in toolbar options
    const getToolbarOptions = () => {
        if (props.toolbarOptions && Array.isArray(props.toolbarOptions)) {
            const optionsToAdd = [];
            // If 'inline' is not in the options, add it to show bold/italic/underline buttons
            if (!props.toolbarOptions.includes('inline')) {
                optionsToAdd.push('inline');
            }
            // If 'list' is not in the options, add it to show bullet points and numbered lists
            if (!props.toolbarOptions.includes('list')) {
                optionsToAdd.push('list');
            }
            // If 'textAlign' is not in the options, add it to show text alignment options
            if (!props.toolbarOptions.includes('textAlign')) {
                optionsToAdd.push('textAlign');
            }
            // Prepend the missing options to the beginning
            if (optionsToAdd.length > 0) {
                return [...optionsToAdd, ...props.toolbarOptions];
            }
            return props.toolbarOptions;
        }
        // If no toolbarOptions provided, use default set with formatting tools
        return ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'emoji', 'history'];
    };
    
    return (
        <div>
            {/*<h1>React Editors</h1>*/}
            <div style={{backgroundColor: 'white', borderRadius: '8px', wordWrap: 'break-word', overflowWrap: 'break-word'}}>
                <Editor
                   ref={editorRef}
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                    onFocus={handleFocus}
                    toolbarClassName={toolbar_class_name}
                    wrapperClassName={wrapper_class_name}
                    editorClassName={editor_class_name}
                    toolbar={{
                       options: getToolbarOptions(),
                       inline: { 
                           inDropdown: false,
                           options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
                           bold: { className: 'toolbar-button' },
                           italic: { className: 'toolbar-button' },
                           underline: { className: 'toolbar-button' },
                           strikethrough: { className: 'toolbar-button' },
                           monospace: { className: 'toolbar-button' },
                       },
                       blockType: {
                           inDropdown: true,
                           options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                           className: 'toolbar-dropdown',
                       },
                       fontSize: {
                           options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                           className: 'toolbar-dropdown',
                       },
                       fontFamily: {
                           options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Courier New', 'Helvetica'],
                           className: 'toolbar-dropdown',
                       },
                       list: { 
                           inDropdown: false,
                           options: ['unordered', 'ordered', 'indent', 'outdent'],
                           unordered: { className: 'toolbar-button' },
                           ordered: { className: 'toolbar-button' },
                           indent: { className: 'toolbar-button' },
                           outdent: { className: 'toolbar-button' },
                       },
                       textAlign: { 
                           inDropdown: true,
                           options: ['left', 'center', 'right', 'justify'],
                       },
                       link: { 
                           inDropdown: true, 
                           defaultTargetOption: '_blank',
                           options: ['link', 'unlink'], 
                       },
                       emoji: {
                           className: 'toolbar-button',
                       },
                    }}
                    placeholder={props.placeholder}
                />
                {bio_error_div}
                {props.page === 'bio' ? 
                    <span style={{ width: '100px', margin: '0px 0px 0px auto' }}> <p style={{textAlign:'right',marginTop:'5px', paddingBottom: '0px', marginBottom: '0px', fontWeight: '600',
                        fontSize: '12px', color: currentContentLength <= textEditorTextLength ? '#AFBED3': 'var(--danger-color)'}}>{currentContentLength} / {textEditorTextLength}</p></span>
                :
                    <>
                        {
                            props.expandTextEditor !== undefined ?
                                <Grid container sx={{ margin: '5px 0px 20px 0px' }}>
                                    <Grid item xs={6}>
                                        {
                                            props.expandTextEditor === true ?
                                                <span
                                                    onClick={props.toggleExpandTextEditor}
                                                    style={{ textAlign: 'left', color: '#AFBED3', fontWeight: '500', fontSize: '14px', cursor: 'pointer' }}>Collapse <FaChevronUp style={{ marginLeft: '2px', fontSize: '10px' }} /></span>
                                                :
                                                <span
                                                    onClick={props.toggleExpandTextEditor}
                                                    style={{ textAlign: 'left', color: '#AFBED3', fontWeight: '500', fontSize: '14px', cursor: 'pointer' }}>Expand <FaChevronDown style={{ marginLeft: '2px', fontSize: '10px' }} /></span>
                                        }
                                    </Grid>
                                    <Grid item xs={6}>
                                        <p style={{ textAlign: 'right', color: currentContentLength <= textEditorTextLength ? '#AFBED3' : 'var(--danger-color)', padding: '0px 0px 0px 0px', fontWeight: '600', fontSize: '14px', margin: '0px 0px 0px 0px' }}>{currentContentLength} / {textEditorTextLength}</p>
                                    </Grid>
                                </Grid>
                                :
                                <p style={{ textAlign: 'right', color: currentContentLength <= textEditorTextLength ? '#AFBED3' : 'var(--danger-color)', padding: '0px 0px 0px 0px', fontWeight: '600', fontSize: '14px', margin: 'px 0px 0px 0px' }}>{currentContentLength} / {textEditorTextLength}</p>
                        }
                    </>
                }
            </div>
        </div>
    );
}
